export default "__VITE_ASSET__TWey9AZH__"